export const transferFailed = (state, action) => {
    state.userAccountProfileState.updated = true;
    state.userAccountProfileState.eventName = "transferFailed";
}